/** @format */

import React from 'react';
import { IconProps } from './Icon.types';

const handleKeyDown = (event, action) => {
  if (event.key === 'Enter' || event.key === ' ') {
    action();
    event.preventDefault();
  }
};

const Icon: React.FC<IconProps> = ({ name, onClick, size, color }) => {
  return (
    <button
      style={{
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        outline: 'none'
      }}
      onClick={onClick}
      onKeyDown={(event) => handleKeyDown(event, onClick)}
      tabIndex={0}
    >
      <i
        className={`fa fa-solid fa-${name} fa-${size}`}
        style={{ color: `${color}` }}
      />
    </button>
  );
};

export default Icon;
